import { useEffect, useState } from 'react';
import Confetti from "react-confetti";
import { useNavigate } from 'react-router-dom';
import BeatLoader from "react-spinners/BeatLoader";

const StoreRedirect = () => {
  const navigate = useNavigate();
  const [redirected, setRedirected] = useState(false);

  useEffect(() => { 
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const playStoreURL = 'https://play.google.com/store/apps/details?id=com.anyaya';
    const appStoreURL = 'https://apps.apple.com/ph/app/anyaya-events-marketplace/id6744569510';

    // Check sessionStorage flag
    const hasRedirected = sessionStorage.getItem('hasRedirectedToStore');

    if (!hasRedirected) {
      // First time: set flag and redirect to store
      sessionStorage.setItem('hasRedirectedToStore', 'true');

      setTimeout(() => {
        if (/android/i.test(userAgent)) {
          window.location.replace(playStoreURL);
        } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
          window.location.replace(appStoreURL);
        } else {
          window.location.replace("https://www.anyaya-events.com/");
        }
        setRedirected(true);
      }, 100);
    } else {
      // User came back from store, clear flag and navigate back to avoid stuck
      sessionStorage.removeItem('hasRedirectedToStore');
      navigate(-1);
    }
  }, [navigate]);

  return (
    <>
      <div className="bg-primary-500 h-screen w-full">
        <div className="fixed inset-0 flex items-center justify-center z-50 text-white">
          <div className="rounded-3xl relative w-500">
            <div className="modal-content">
              <div className="flex justify-right h-16 ">
                <div
                  className="anyaya h-full w-full"
                  style={{ backgroundPositionX: "center" }}
                />
              </div>
              <div className="mt-10" style={{ textAlignLast: "center" }}>
                <BeatLoader color="#fff" />
                {redirected && (
                  <div className="mt-6 text-center">
                    <p>If you are still here, please try going back manually:</p>
                    <button
                      onClick={() => navigate(-1)}
                      className="mt-2 px-4 py-2 bg-white text-primary-500 rounded"
                    >
                      Go Back
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Confetti
        width={window.innerWidth - 20}
        height={window.innerHeight - 20}
        tweenDuration={1}
      />
    </>
  );
};

export default StoreRedirect;
